import matchEntities from '../src/shared/entityHelpers';

const featureFlags = {
  enablePublicCitiesPages: () => {
    return matchEntities(['NETHERLANDS']);
  },
  enabledAccreditations: () => {
    return matchEntities(['UK']);
  },
};
export default featureFlags;
